import { ajaxErrorAlert, ajaxPost, toggleBetweenElements } from "./utils";
import { getJsContext, getRecaptchaToken, getUrlTranslation } from "../app";

$(function () {
  const checkPolicyNumberForm = $("#checkPolicyNumberForm");
  checkPolicyNumberForm.on("submit", (e) => {
    e.preventDefault();
    const form = $(e.target);
    toggleBetweenElements(payForPolicyNumberForm, checkPolicyNumberForm);
    getRecaptchaToken(form).then(() => {
      const data = form.serializeArray();
      checkPolicyNumberForm.loading({
        loadingText: getJsContext("checking") + "...",
        position: "left top",
        extraClasses: "w110 p-4",
      });
      ajaxPost(getUrlTranslation("/check-policy-number/"), data, form)
        .then((response) => {
          $("#_policy_number").val(response["policy_number"]);
          $("#_insured_person").val(response["insured_person"]);
          $("#_product_name").val(response["product_name"]);
          $("#_debt").val(String(response["debt"]));
          $("#_debt_for_today").val(String(response["debt_for_today"]));

          $("input[name=payment_amount]").val("");
          const url = `/policy/${response["policy_number"]}/`;
          window.history.pushState({}, "", getUrlTranslation(url));
          toggleBetweenElements(
            checkPolicyNumberForm,
            payForPolicyNumberForm,
            500,
            () => {
              $("input[name=payment_amount]").focus();
            },
          );
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  });

  const payForPolicyNumberForm = $("#payForPolicyNumberForm");
  payForPolicyNumberForm.on("submit", (e) => {
    e.preventDefault();
    const form = $(e.target);

    getRecaptchaToken(form).then(() => {
      const policyNumber = $("input[name=policy_number]").val();
      const paymentAmount = $("input[name=payment_amount]").val();
      const data = {
        policy_number: policyNumber,
        payment_amount: paymentAmount,
        recaptcha: form.find("input[name=recaptcha]").val(),
        action: "policy",
      };
      payForPolicyNumberForm.loading({
        loadingText: getJsContext("please_wait") + "...",
        position: "left top",
        extraClasses: "w110 p-4",
      });
      ajaxPost(getUrlTranslation("/get-payment-url/"), data, form)
        .then((response) => {
          payForPolicyNumberForm.loading({
            loadingText: getJsContext("redirecting") + "...",
            position: "left top",
            extraClasses: "w110 p-4",
          });
          window.location.href = String(response["redirect_url"]);
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  });

  const policyNumberInput = $("input[name=policy_number]");
  if (policyNumberInput.length > 0 && policyNumberInput.val() !== "") {
    policyNumberInput.closest("form").trigger("submit");
  }

  $("#backToCheckPolicyNumberForm").on("click", () => {
    checkPolicyNumberForm.loading({ action: "hide" });
    payForPolicyNumberForm.find("#alertWrapperParent").empty();
    window.history.pushState({}, "", getUrlTranslation(`/policy/`));
    toggleBetweenElements(
      payForPolicyNumberForm,
      checkPolicyNumberForm,
      500,
      () => {
        $("input[name=policy_number]").trigger("focus");
      },
    );
  });
});
